import { render, staticRenderFns } from "./PaymentsFailedPage.vue?vue&type=template&id=6c8ff00e&"
import script from "./PaymentsFailedPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsFailedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports